/*
 * Sort an array of object by the name key
 *
 * @param arr Array[{Object}]
 * return Array[{Object}]
 */
function sortArrayObjectsByName(arr) {
  return arr.sort((a, b) => {
    const nameA = a.name.toUpperCase()
    const nameB = b.name.toUpperCase()

    if (nameA < nameB) {
      return -1
    }
    if (nameA > nameB) {
      return 1
    }

    return 0
  })
}

/*
 * Group array opject by the first letter of the name
 * Used to create the brands directory list
 *
 * @param arr Array[{Object}]
 * return Object
 */
function groupArrayObjects(
  arr,
  currentCategory,
  currentvirtualService = 'ALL'
) {
  const NUMBER_KEY = '#'
  const orderedArray = sortArrayObjectsByName(arr)
  const numberArray = []
  const currentSevice = currentvirtualService.toUpperCase()

  const groupedArray = orderedArray.reduce((obj, item) => {
    const newObj = { ...obj }
    const key = item.name[0].toUpperCase()

    const cats = item.categories
      ? item.categories.reduce((catArr, cat) => {
          catArr.push(cat.label)
          return catArr
        }, [])
      : []

    const services = item.services
      ? item.services.reduce((catArr, cat) => {
          if (cat.title) {
            catArr.push(cat.title.toUpperCase())
          }
          return catArr
        }, [])
      : []

    if (
      (currentSevice === 'ALL' && currentCategory === 'ALL') ||
      (services.indexOf(currentSevice) > -1 &&
        cats.indexOf(currentCategory) > -1) ||
      (currentSevice === 'ALL' && cats.indexOf(currentCategory) > -1) ||
      (currentCategory === 'ALL' && services.indexOf(currentSevice) > -1)
    ) {
      // if the key isn't a letter
      // add to the number stack
      if (!key.match(/[A-Z]/)) {
        numberArray.push(item)

        return newObj
      }

      // if the key doesn't exist in the obj
      // add it
      if (!newObj[key]) newObj[key] = []

      newObj[key].push(item)
    }

    return newObj
  }, {})

  const groupedObject = {
    ...groupedArray,
  }

  if (numberArray.length > 0) {
    groupedObject[NUMBER_KEY] = numberArray
  }

  return groupedObject
}

function getBrandCategories(brands) {
  const categories = brands.reduce((obj, brand) => {
    const newObj = { ...obj }
    if (brand.categories) {
      brand.categories.forEach((cat) => {
        if (!newObj[cat.label]) {
          newObj[cat.label] = cat.name
        }
      })
    }

    return newObj
  }, {})

  return categories
}

function getVirtualServices(services) {
  const virtualServices = services.reduce((obj, service) => {
    const newObj = { ...obj }
    if (service.label && !newObj[service.label]) {
      newObj[service.label] = service.label
    }

    return newObj
  }, {})

  return virtualServices
}

function servicesFormatted({ labels: vsLabels, contactMethod }) {
  if (!contactMethod) return null

  const virtualshoppingLabels = {}
  const virtualServices = []

  // eslint-disable-next-line array-callback-return
  vsLabels.map((item) => {
    Object.entries(item).forEach(([key, value]) => {
      virtualshoppingLabels[key] = value
    })
  })

  // eslint-disable-next-line array-callback-return
  contactMethod.map((item) => {
    if (item.bookingUrl && item.bookingUrlIcon) {
      virtualServices.push({
        icon: item.bookingUrlIcon,
        label: item.bookingUrl,
      })
    }

    if (item.emailIcon && item.emailAddressLabel) {
      virtualServices.push({
        icon: item.emailIcon,
        label: item.emailAddressLabel,
      })
    }

    if (item.phoneIcon && item.phoneNumberLabel) {
      virtualServices.push({
        icon: item.phoneIcon,
        label: item.phoneNumberLabel,
      })
    }

    if (item.productCatalogueIcon && item.productCatalogueLabel) {
      virtualServices.push({
        icon: item.productCatalogueIcon,
        label: item.productCatalogueLabel,
      })
    }

    if (item.whatsapp && item.whatsappIcon) {
      virtualServices.push({
        icon: item.whatsappIcon,
        label: item.whatsapp,
      })
    }
  })

  return {
    ...virtualshoppingLabels,
    contactMethod: virtualServices,
  }
}

export default {
  getBrandCategories,
  groupArrayObjects,
  sortArrayObjectsByName,
  getVirtualServices,
  servicesFormatted,
}
